import { Component } from '@ecs/Component';

export class MineLayer implements Component {
  readonly type = 'MineLayer';

  constructor(
    public cooldown: number = 2600,
    public maxActiveMines: number = 5,
    public mineDamage: number = 2,
    public mineLifetime: number = 900, // frames
    public lastDrop: number = 0,
    public mineIds: number[] = []
  ) {}
}
